import { GridColumnHeaderParams } from "@mui/x-data-grid-pro";

import { IconNameEnum } from "../../../../../components/Icon";
import { ContainerTypesFilter } from "../../../../../components/TableFilters/ContainerTypesFilter";
import { DateTimeFilter } from "../../../../../components/TableFilters/DateTimeFilter";
import { OptionsListFilter } from "../../../../../components/TableFilters/OptionsListFilter";
import { RfidFilter } from "../../../../../components/TableFilters/RfidFilter";
import { TextFilter } from "../../../../../components/TableFilters/TextFilter";
import { WeightFilter } from "../../../../../components/TableFilters/WeightFilter";
import { TableHeaderCell } from "../../../../../components/TableHeaderCell";
import { removeFilter, setFilter, setOrdering } from "../../../../../reducers/wagonsReportStateReducer";
import {
  getWagonsContainerTypeOptions,
  getWagonsReportFilterIsActive,
  getWagonsReportFilterValue,
  getWagonsReportListPlateNumberOptions,
  getWagonsReportOrderingValue,
} from "../../../../../selectors/wagonsReport";
import { wagonReportTableColumnType } from "../WagonsReportTableUtils";

const TABLE_NAME = "wagonsReport";

interface IHeaderCellProps {
  params: GridColumnHeaderParams;
}

const selectFilters = (type: string) => {
  switch (type) {
    case wagonReportTableColumnType.date:
      return (
        <DateTimeFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getWagonsReportFilterValue}
          filterUpdateAction={setFilter}
        />
      );
    case wagonReportTableColumnType.location:
      return (
        <TextFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getWagonsReportFilterValue}
          filterUpdateAction={setFilter}
          iconName={IconNameEnum.location}
        />
      );
    case wagonReportTableColumnType.containerType:
      return (
        <ContainerTypesFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getWagonsReportFilterValue}
          filterUpdateAction={setFilter}
          optionsSelectorValue={getWagonsContainerTypeOptions}
        />
      );
    case wagonReportTableColumnType.weight:
      return (
        <WeightFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getWagonsReportFilterValue}
          filterUpdateAction={setFilter}
        />
      );
    case wagonReportTableColumnType.rfid:
      return (
        <RfidFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getWagonsReportFilterValue}
          filterUpdateAction={setFilter}
        />
      );
    case wagonReportTableColumnType.plateNumber:
      return (
        <OptionsListFilter
          tableName={TABLE_NAME}
          fieldName={type}
          filterSelectorValue={getWagonsReportFilterValue}
          filterUpdateAction={setFilter}
          optionsSelectorValue={getWagonsReportListPlateNumberOptions}
        />
      );
    default:
      return <div />;
  }
};

export const WagonsReportTableHeader: React.FC<IHeaderCellProps> = ({ params }) => {
  return (
    <TableHeaderCell
      tableName={TABLE_NAME}
      params={params}
      selectorOrdering={getWagonsReportOrderingValue}
      selectorFilterIsActive={getWagonsReportFilterIsActive}
      removeFilterUpdateAction={removeFilter}
      selectFilters={selectFilters}
      orderingUpdateAction={setOrdering}
    />
  );
};
